import React, { FC } from "react";
import ReactSelect from "react-select";
import { BaseProps } from "../elements/base";
import SelectStyle, { ErrorText } from "./select.style";

type Props = {
  className?: string;
  labelText?: string;
  labelPosition?: "top" | "bottom" | "left" | "right";
  selectProps: any;
  touched?: boolean;
  error?: string;
};

const Select: FC<Props & BaseProps> = ({
  className,
  labelText,
  labelPosition,
  selectProps,
  touched,
  error,
  width = [1],
  ...props
}) => {
  // Add all classes to an array
  const addAllClasses = ["tgp__select"];

  // Add label position class
  if (labelPosition) {
    addAllClasses.push(`label_${labelPosition}`);
  }

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  const LabelField = labelText && (
    <span className="tgp__field-label">{labelText}</span>
  );

  const position = labelPosition || "top";

  return (
    <SelectStyle className={addAllClasses.join(" ")} width={width} {...props}>
      {position === "left" || position === "right" || position === "top"
        ? LabelField
        : ""}
      {error && <ErrorText>{error}</ErrorText>}
      <ReactSelect
        className="select-field__wrapper"
        classNamePrefix="select"
        menuPortalTarget={typeof document !== "undefined" && document.body}
        // styles={{
        //   option: (styles, { isSelected }) => ({
        //     ...styles,
        //     backgroundColor: isSelected ? "red" : null
        //   })
        // }}
        {...selectProps}
      />
      {position === "bottom" && LabelField}
    </SelectStyle>
  );
};

Select.defaultProps = {
  labelPosition: "top"
};

export default Select;
